<template lang="pug">
.organization-theme
  h3 {{ $t('organizationTheme.title') }}
  p {{ $t('organizationTheme.description') }}
  form
    .row
      //- .col-12.col-md-6
        .form-group
          label(for='email') {{ $t('organizationTheme.subdomain.label') }}
          .form-control-icon
            icon(name='laptop' :fix-width='true')
            .input-group.mb-3
              input.form-control(
                type='text'
                :placeholder='$t("organizationTheme.subdomain.placeholder")'
                aria-label='Subdominio'
                aria-describedby='basic-addon2'
              )
              span#basic-addon2.input-group-text .assine.online
      .col-12
        h6.block-title {{ $t('organizationTheme.logo.title') }}
        p {{ $t('organizationTheme.logo.description') }}
        .form-group
          input(
            @change='uploadFile'
            ref='file'
            type='file'
          )
        .card.card-logo-preview(v-if='savedLogo || logo')
          img.card-img-top.logo(:src='logo ? logo : savedLogo')
          .card-body
            .text-end
              button(@click='deleteLogo()' type='button')
                icon(:fix-width='true' name='trash-can')
        h6.block-title {{ $t('organizationTheme.avatar.title') }}
        p {{ $t('organizationTheme.avatar.description') }}
      .col-12
        ul.theme-colors-list.list-unstyled
          .row
            .col-12.col-sm-6.col-md-3
              li.list-item
                p {{ $t('organizationTheme.avatar.backgroundColor') }}
                input.color-picker.shadow(
                  type='color'
                  v-model='palette.avatar_background_color'
                )
            .col-12.col-sm-6.col-md-3
              li.list-item
                p {{ $t('organizationTheme.avatar.textColor') }}
                input.color-picker.shadow(
                  type='color'
                  v-model='palette.avatar_text_color'
                )
            .col-12.col-sm-6.col-md-3
              li.list-item
                p {{ $t('organizationTheme.avatar.simulation') }}
                .color-picker
                  .color-theme-simulator.text-center(
                    :style='simulationPaletteStyleAvatar()'
                  ) AO
      .col-12.mt-3
        h6.block-title {{ $t('organizationTheme.header.title') }}
        p {{ $t('organizationTheme.header.description') }}
        ul.theme-colors-list.list-unstyled
          .row
            .col-12.col-sm-6.col-md-3
              li.list-item
                p {{ $t('organizationTheme.header.backgroundColor') }}
                input.color-picker.shadow(
                  type='color'
                  v-model='palette.navbar_background_color'
                )
            .col-12.col-sm-6.col-md-3
              li.list-item
                p {{ $t('organizationTheme.header.textColor') }}
                input.color-picker.shadow(
                  type='color'
                  v-model='palette.navbar_text_color'
                )
            .col-12.col-sm-6.col-md-3
              li.list-item
                p {{ $t('organizationTheme.header.simulation') }}
                .color-picker.color-theme-simulator.text-center(
                  :style='simulationPaletteStyleNavBar()'
                )
                  icon(:fix-width='true' name='bell')
                  icon.ml-3(:fix-width='true' name='circle-user')
      .col-12.mt-3
        h6.block-title {{ $t('organizationTheme.buttons.title') }}
        p {{ $t('organizationTheme.buttons.description') }}
        ul.mt-3.theme-colors-list.list-unstyled
          .row
            .col-12.col-sm-6.col-md-3
              li.list-item
                p {{ $t('organizationTheme.buttons.backgroundColor') }}
                input.color-picker.shadow(
                  type='color'
                  v-model='palette.button_background_color'
                )
            .col-12.col-sm-6.col-md-3
              li.list-item
                p {{ $t('organizationTheme.buttons.textColor') }}
                input.color-picker.shadow(
                  type='color'
                  v-model='palette.button_text_color'
                )
            .col-12.col-sm-6.col-md-3
              li.list-item
                p {{ $t('organizationTheme.buttons.simulation') }}
                button.btn(
                  :style='simulationPaletteStyleButton()'
                  type='button'
                )
                  | {{ $t('organizationTheme.buttons.simulationText') }}
      .col-12.text-end
        button.btn.btn--cancel-red-text.mt-2(
          data-bs-target='#remove-theme-modal'
          data-bs-toggle='modal'
          style='margin-right: 1rem'
          type='button'
        ) {{ $t('organizationTheme.restoreTheme') }}
        button.mt-2.btn.btn-secondary(
          @click='saveOrganizationTheme'
          type='button'
        ) {{ $t('organizationTheme.save') }}
  remove-theme-modal(@refresh='fetchTheme')
</template>
<script>
import WhiteLabelService from '@/modules/business/services/http/organizations/WhiteLabelService';
import RemoveThemeModal from '@/modules/business/components/organisms/modals/RemoveThemeModal.vue';
import alert from '@/modules/account/common/alert';
import Icon from '@/ui/atoms/Icon.vue';
import LocalStorage from '@/services/LocalStorage';
import AppConfig from '@/config';

export default {
  components: {
    Icon,
    RemoveThemeModal,
  },
  props: {
    organization: Object,
  },
  data() {
    return {
      palette: {
        avatar_background_color: '#000000',
        avatar_text_color: '#ffffff',
        navbar_background_color: '#000000',
        navbar_text_color: '#ffffff',
        button_background_color: '#000000',
        button_text_color: '#ffffff',
      },
      file: '',
      logo: '',
    };
  },
  async created() {
    this.$loading(true);
    try {
      this.fetchTheme();
    } finally {
      this.$loading(false);
    }
  },
  computed: {
    savedLogo() {
      if (
        this.$store.state.organizations.selected.logo ===
        `${AppConfig.cdnPath}/assets/images/rebrand-intellisign/intellisign-logo.png`
      ) {
        return false;
      }
      return this.$store.state.organizations.selected.logo;
    },
  },
  methods: {
    simulationPaletteStyleAvatar() {
      return `background-color: ${this.palette.avatar_background_color}; color: ${this.palette.avatar_text_color};`;
    },
    simulationPaletteStyleNavBar() {
      return `background-color: ${this.palette.navbar_background_color}; color: ${this.palette.navbar_text_color};`;
    },
    simulationPaletteStyleButton() {
      return `background-color: ${this.palette.button_background_color}; color: ${this.palette.button_text_color};`;
    },
    async saveOrganizationTheme() {
      this.$loading(true);
      try {
        const data = {
          avatar_background_color: this.palette.avatar_background_color,
          avatar_text_color: this.palette.avatar_text_color,
          navbar_background_color: this.palette.navbar_background_color,
          navbar_text_color: this.palette.navbar_text_color,
          button_background_color: this.palette.button_background_color,
          button_text_color: this.palette.button_text_color,
        };
        WhiteLabelService.update(
          this.$store.state.organizations.selected.id,
          data
        ).then((ret) => {
          this.palette = ret.data;
        });

        if (this.file[0]) {
          const responseLogo = await WhiteLabelService.updateLogo(
            this.$store.state.organizations.selected.id,
            this.file[0]
          );
          this.$store.commit(
            'organizations/setOrganizationLogo',
            responseLogo.data.logo
          );
        }
        this.$store.dispatch('organizations/getSelected');
        alert.fireAlert(this.$('organizationTheme.successMessage'), {
          classes: 'alert-success',
          styles:
            'background-color: #d4edda; border-color: #c3e6cb; color: #155724;',
          icon: 'circle-check',
        });
      } finally {
        this.$loading(false);
      }
    },
    uploadFile() {
      this.file = this.$refs.file.files;
      this.logo = URL.createObjectURL(this.$refs.file.files[0]);
    },
    async deleteLogo() {
      this.$loading(true);
      try {
        await WhiteLabelService.deleteLogo(
          this.$store.state.organizations.selected.id
        );
        this.$refs.file.value = null;
        this.logo = '';
        this.$store.dispatch('organizations/getSelected');
      } finally {
        this.$loading(false);
      }
    },
    async fetchTheme() {
      const whitelabelResult = await WhiteLabelService.list(
        LocalStorage.get('organization')
      );
      this.palette = whitelabelResult.data;
      this.$store.dispatch('organizations/getSelected');
    },
  },
};
</script>
<style lang="stylus">
input[type=file]::file-selector-button
  background: none
  border-color: #013D52
  color: #013D52
  border-radius: .3rem
  font-weight: 600
  font-size: 1rem
  padding: 0.4rem 1.2rem
  margin-right: .3rem
  cursor: pointer
input[type=file]::file-selector-button:hover
  opacity: .8
.card-logo-preview
  margin-top: 1rem
  margin-bottom: 1rem
  width: 168px
</style>
